import React from "react";
import Loadable from "react-loadable";
import { RouteComponentProps } from "react-router-dom";

import { LOADABLE_COMPONENT_DELAY } from "@config/consts";

import { AccountCreationPageSkeleton } from "./AccountCreation.skeletons";

const LoadableAccountCreationDetails: any = Loadable({
  loader: () => import("./AccountCreationDetails/AccountCreationDetails"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.AccountCreationDetails;
    return <Component {...props} />;
  },
  loading: AccountCreationPageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const AccountCreation = (props: RouteComponentProps): React.ReactElement => {
  return <LoadableAccountCreationDetails {...props} />;
};

export { AccountCreation };
